import { generatePath } from 'react-router-dom';
import type { Path } from '@router'; // generouted typ Path

type Query = Record<string, string | number | boolean | undefined | null>;

export function withQuery<T extends Path>(path: T, params: Record<string, string | number | undefined> = {}, query: Query = {}): string {
  const pathname = generatePath(path as string, params);

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  }

  const search = searchParams.toString();
  return search ? `${pathname}?${search}` : pathname;
}
